<div class="diagram -parent">
  @if (scenario && !fallbackMode) {
  <div class="diagram -sidebar">
    <div class="diagram -scenarios">
      @for (scenario of scenarios; track scenario; let i = $index) {
      <div class="diagram -scenarios -wrapper noSelector">
        <wp-radio
          [label]="scenario.name"
          [checked]="i === selectedScenarioIndex"
          [value]="scenario.name"
          (wpChange)="selectScenario(i)"></wp-radio>
      </div>
      }
    </div>
    <div class="diagram -information">
      <label class="diagram -information -title">Information</label>
      <p class="diagram -information -description">{{ scenario.description }}</p>
    </div>
  </div>
  } @if (!fallbackMode) {
  <div class="diagram -diagram-convergence">
    <svg [ngClass]="service"></svg>
  </div>
  } @if (fallbackMode) {
  <div class="diagram -fallback">
    <img [src]="fallbackImage" alt="diagram-fallback-image" />
  </div>
  }
</div>
